import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    minWidth: 800,
    position: 'relative',
    flexDirection: 'column',
    display: 'flex',
    backgroundColor: theme.colors.form__background_primary,
    padding: theme.spacing(12)
  },
  closeButton: {
    position: 'absolute',
    right: 10,
    top: 10
  },
  title: {
    color: theme.colorPalette.green_75,
    fontSize: 40,
    fontWeight: 300,
    padding: 0
  },
  subtitle: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.colorPalette.green_80
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginTop: theme.spacing(8)
  },
  returnButton: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '24px',
    width: 120
  },
  submitButton: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '24px',
    width: 324
  }
});

export default makeStyles(styles);
